import { render, staticRenderFns } from "./PatientFoundModalComponent.vue?vue&type=template&id=438eabe6"
import script from "./PatientFoundModalComponent.vue?vue&type=script&lang=js"
export * from "./PatientFoundModalComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports